import TableContainer from "@mui/material/TableContainer";
import {
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  FormControlLabel,
  Checkbox,
  Stack,
} from "@mui/material";
import { BandBooking } from "../../__generated__/graphql";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { LinkButton } from "../../components/LinkButton";
import {
  getZonedDate,
  useGetDisplayDate,
  useGetTimezone,
} from "../../components/ZonedDateTimePicker";
import { DateTime, Settings } from "luxon";
import { ImageSize } from "../bands";
import { useIsSuperAdmin } from "../../App";
import { CompressArtistImage } from "../band/edit/compressArtistImage";
import HasImageIcon from "../../components/HasImageIcon";
interface IBandTableProps {
  bands: BandBooking[];
  eventTimezone: string;
  getImageSize: boolean;
  onRemoveBooking?: (bookingId: string, bandName: string) => void;
  removingBookingIds?: Set<string>;
}

const BandsTable = ({
  bands,
  eventTimezone,
  getImageSize,
  onRemoveBooking,
  removingBookingIds,
}: IBandTableProps) => {
  const { getFormattedDate } = useGetDisplayDate();
  const isSuperAdmin = useIsSuperAdmin();

  return (
    <>
      <h2>{bands[0].stage?.name ?? 'No Stage'}</h2>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left" width="20%">
                name
              </TableCell>
              <TableCell align="left" width="10%">
                times ({eventTimezone})
              </TableCell>
              <TableCell align="left" width="10%">
                duration
              </TableCell>
              <TableCell align="left" width="10%">
                stage
              </TableCell>
              <TableCell align="left" width="10%">
                has image
              </TableCell>
              {getImageSize && <TableCell align="left">has image</TableCell>}
              <TableCell align="left" width="25%">
                actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bands
              // @ts-ignore
              .sort((a, b) => new Date(a.startTime) - new Date(b.startTime))
              .map((row) => {
                const bookingId =
                  (row as unknown as { bookingId?: string })?.bookingId ?? row.id;
                const isRemoving = removingBookingIds?.has(bookingId) ?? false;

                return (
                  <TableRow key={bookingId ?? row.id}>
                    <TableCell align="left">{row.band.name}</TableCell>
                    <TableCell align="left">
                      {getFormattedDate(row.startTime, eventTimezone)} -{" "}
                      {getFormattedDate(row.endTime, eventTimezone)}
                    </TableCell>
                    <TableCell align="left">{row.duration ?? '-'}</TableCell>
                    <TableCell align="left">{row.stage?.name ?? "-"}</TableCell>
                    <TableCell align="left">
                      <HasImageIcon
                        hasImage={
                          !!(row.band.imageUrl && row.band.imageUrl.length > 0)
                        }
                      />
                    </TableCell>
                    {getImageSize && (
                      <TableCell align="left">
                        <ImageSize imageUrl={row.band.imageUrl} />
                      </TableCell>
                    )}
                    <TableCell align="left">
                      <Stack direction="row" spacing={1} flexWrap="wrap">
                        <LinkButton path={`/booking/${bookingId}`} text="View" />
                        <LinkButton
                          path={`/band/${row.band.id}`}
                          text="View Band"
                        />
                        {onRemoveBooking && (
                          <Button
                            size="small"
                            variant="outlined"
                            color="error"
                            onClick={() =>
                              onRemoveBooking(bookingId, row.band.name)
                            }
                            disabled={isRemoving}
                          >
                            {isRemoving ? "Removing..." : "Remove booking"}
                          </Button>
                        )}
                        {isSuperAdmin && getImageSize && (
                          <CompressArtistImage band={row.band} />
                        )}
                      </Stack>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default BandsTable;
